var React = require('react');

function ApprovedReminder (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9ZM14 7.00421L12.5858 5.59L8 10.19L5.91421 8.08579L4.5 9.5L8 13L14 7.00421Z","fill":"black"}));
}

ApprovedReminder.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = ApprovedReminder;

ApprovedReminder.default = ApprovedReminder;
